export function sliderSection() {
    const $window = $(window);
    const $slider = $(".slider-section");
    const $prev = `
    <button type="button" class="arrow-button big slick-prev">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.36459 12.0924L7.72819 11.456L11.7343 7.44993L1.1765 7.44993L1.1765 6.55261L11.7343 6.55262L7.72819 2.5465L8.36459 1.9101L13.4558 7.00127L8.36459 12.0924Z" fill="#111111"/>
        </svg>
    </button>`;
    const $next = ` 
    <button type="button" class="arrow-button big slick-next">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.36459 12.0924L7.72819 11.456L11.7343 7.44993L1.1765 7.44993L1.1765 6.55261L11.7343 6.55262L7.72819 2.5465L8.36459 1.9101L13.4558 7.00127L8.36459 12.0924Z" fill="#111111"/>
        </svg>
    </button>`;
    let $firstSlide = $slider.find(".slick-active");
    let $firstVideo = $firstSlide.find("video");
    $slider.slick({
        infinite: false,
        arrows: true,
        fade: true,
        dots: true,
        prevArrow: $prev,
        nextArrow: $next,
        adaptiveHeight: true,
        pauseOnHover: false,
        autoplay: true,
        autoplaySpeed: 2700,
        slidesToShow: 1,
        slidesToScroll: 1
    });
    $slider.on("beforeChange", function () {
        let $video = $slider.find("video");
        if ($video.length) {
            $video.get(0).pause();
        }
    });
    $slider.on("afterChange", function (event, slick, currentSlide) {
        let $video = $(slick.$slides[currentSlide]).find("video");
        if ($video.length) {
            $video.get(0).play();
        }
    });
    if ($firstVideo.length) {
        $firstVideo.get(0).play();
    }
    $(window).on("resize orientationchange", function () {
        $slider.slick("setPosition");
    });
    $window.on("load scroll", function () {
        let $winTop = $window.scrollTop();
        let $windowBottomPosition = ($winTop + $window.height());
        $slider.each(function () {
            let $this = $(this);
            let $sectionTop = $this.offset().top;
            if ($windowBottomPosition > $sectionTop) {
                $slider.slick("slickPlay");
            } else {
                $slider.slick("slickPause");
            }
        });
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/sliderSection.js